import { IStateRepair } from "@/apps/merchant3/models/IStateRepair";
import {
  ActivationMethod,
  RepairStatus,
  RepairType,
} from "@/apps/merchant3/types/DeviceRepair";

const mutations = {
  RESET_REPAIR_STATES: (state: IStateRepair): void => {
    state.activationMethod = null;
    state.additionalContactEmail = null;
    state.additionalContactPhone = null;
    state.clientName = null;
    state.deviceFamilyId = null;
    state.deviceModelName = null;
    state.phoneProblemDescription = null;
    state.status = null;
    state.statuses = [];
    state.repairType = null;
    state.samePhysicalDevice = true;
  },

  SET_ACTIVATION_METHOD: (
    state: IStateRepair,
    payload: ActivationMethod
  ): void => {
    state.activationMethod = payload;
  },

  SET_ADDITIONAL_CONTACT_EMAIL: (
    state: IStateRepair,
    payload: string
  ): void => {
    state.additionalContactEmail = payload;
  },

  SET_ADDITIONAL_CONTACT_PHONE: (
    state: IStateRepair,
    payload: string
  ): void => {
    state.additionalContactPhone = payload;
  },

  SET_CLIENT_NAME: (state: IStateRepair, payload: string): void => {
    state.clientName = payload;
  },

  SET_DEVICE_FAMILY_ID: (state: IStateRepair, payload: number): void => {
    state.deviceFamilyId = payload;
  },

  SET_DEVICE_MODEL_NAME: (state: IStateRepair, payload: string): void => {
    state.deviceModelName = payload;
  },

  SET_DEVICE_TAG: (state: IStateRepair, payload: string): void => {
    state.deviceTag = payload;
  },

  SET_NEW_DEVICE_MODEL_NAME: (state: IStateRepair, payload: string): void => {
    state.newDeviceModelName = payload;
  },

  SET_PHONE_PROBLEM_DESCRIPTION: (
    state: IStateRepair,
    payload: string
  ): void => {
    state.phoneProblemDescription = payload;
  },

  SET_STATUSES: (state: IStateRepair, payload: RepairStatus[]): void => {
    state.statuses = payload;
  },

  SET_REPAIR_TYPE: (state: IStateRepair, payload: RepairType): void => {
    state.repairType = payload;
  },

  SET_SAME_PHYSICAL_DEVICE: (state: IStateRepair, payload: boolean): void => {
    state.samePhysicalDevice = payload;
  },

  SET_STATUS: (state: IStateRepair, payload: RepairStatus): void => {
    state.status = payload;
  },

  SET_STATUS_TO_PREVIOUS: (state: IStateRepair): void => {
    switch (state.status) {
      case RepairStatus.NEW:
        state.status = RepairStatus.SELECT_REPAIR_TYPE;
        break;
      case RepairStatus.SET_TO_REMOVABLE:
      case RepairStatus.FULLY_UNLOCKED:
        state.status = RepairStatus.NEW;
        break;
      case RepairStatus.FACTORY_RESET_IN_PROCESS:
      case RepairStatus.APP_REMOVED:
        state.status = RepairStatus.SET_TO_REMOVABLE;
        break;
      case RepairStatus.SEND_WARRANTOR:
        if (state.activationMethod === ActivationMethod.KNOX_GUARD) {
          state.status = RepairStatus.FULLY_UNLOCKED;
        } else {
          state.status = RepairStatus.APP_REMOVED;
        }
        break;
      case RepairStatus.BACK_FROM_WARRANTOR:
        state.status = RepairStatus.SEND_WARRANTOR;
        break;
      case RepairStatus.DEVICE_SWAP:
      case RepairStatus.NO_WARRANTY:
        state.status = RepairStatus.BACK_FROM_WARRANTOR;
        break;
      case RepairStatus.SELECT_REPLACEMENT_DEVICE:
        state.status = RepairStatus.DEVICE_SWAP;
        break;
    }
  },
};

export default mutations;
